<template>
  <footer class="navbar-footer navbar-footer-pdv">
    <div class="container">
      <div class="row">
        <div class="">
          <ul class="col atalhos">
            <li v-if="checkout.open">
              <a @click="handleConfiguracoes()">
                Caixa <span>{{ checkout.identification }}</span>
                <br />
                <span
                  style="color: #6d747c !important; font-weight: 400"
                  v-if="checkout.open"
                  class="text-nowrap"
                >
                  Aberto: {{ checkout.open }}
                </span>
              </a>
            </li>
            <li v-if="!checkout.open">
              <Button type="success" @click="openCheckout"> Abrir Caixa</Button>
            </li>
            <li v-if="checkout.open">
              <b-button class="btn-fechar" @click="checkoutClose">
                Fechar Caixa
              </b-button>
            </li>
            <li v-if="checkout.open">
              <Button type="success" @click="movimentationCheckout" class="p-2">
                Sangria / Suprimento
              </Button>
            </li>
            <!-- <li v-if="isClientFromSC && !isGerencial()">
              <Button type="success" @click="openMenuFiscal" class="p-2">
                Menu Fiscal - AWS
              </Button>
            </li> -->
            <li v-if="checkout.open">
              <a @click="handleConfiguracoes()">
                Configurações <span>(ALT + F1)</span>
              </a>
            </li>
            <li v-if="checkout.open">
              <a @click="openAtalhos()"> Atalhos <span>(ALT + F2)</span> </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { Button } from '@/components/Form';
import { ClientMixin } from '../../../../../Application';

export default {
  name: 'pdv-footer',
  mixins: [ClientMixin],
  components: {
    Button,
  },
  props: {
    configuracoes: {
      default: () => {},
      type: Function,
    },
    checkout: {
      type: Object,
      required: false,
    },
    openCheckout: {
      type: Function,
      required: true,
    },
    openAtalhos: {
      type: Function,
      required: true,
    },
    movimentationCheckout: {
      type: Function,
      required: true,
    },
    checkoutClose: {
      type: Function,
      required: true,
    },
    openMenuFiscal: {
      type: Function,
      required: true,
    },
  },
  methods: {
    isGerencial() {
      const { gerencial } = this.$route.params;

      if (gerencial) return true;

      return false;
    },
    handleConfiguracoes() {
      return this.configuracoes();
    },
    handleAbrirVenda() {
      return this.abrirVenda();
    },
    handleDesconto() {
      return this.desconto();
    },
    handleAcrescimo() {
      return this.acrescimo();
    },
    handleCliente() {
      return this.cliente();
    },
    handlePagamento() {
      return this.pagamento();
    },
    handleCancelar() {
      return this.cancelar();
    },
    handleFinalizar() {
      return this.finalizar();
    },
  },
  async mounted() {
    await this.getClient();
  },
};
</script>

<style>
.atalhos a {
  cursor: pointer;
}

.atalhos button {
  text-transform: capitalize !important;
}

.atalhos a span {
  color: var(--color-primary) !important;
  font-weight: bold;
}

.atalhos button span {
  font-size: 14px !important;
}

.navbar-footer {
  position: fixed;
}

.finalizar a,
.finalizar span {
  color: #fff !important;
  font-size: 1.15rem !important;
}

.finalizar {
  background: var(--color-primary);
  padding: 8px 30px;
  border-radius: 5px;
}

.btn-fechar {
  font-size: 1.15rem !important;
  background: #eef0ef !important;
  color: #4f4f4f !important;
}

.btn-fechar:hover {
  background: var(--color-secondary) !important;
  color: #fff !important;
}
</style>
